import { ENVIRONMENTS_HAVE_API_SWITCHER } from '@/enums/globals';
import { STORAGE_KEYS } from '@/util/storage';
import axiosObject from './axios.config';

export enum HttpMethods {
  POST = 'post',
  GET = 'get',
  PUT = 'put',
  DELETE = 'delete',
  PATCH = 'patch',
}

type TRequestType = {
  url: string;
  method: HttpMethods;
  data?: any;
  params?: any;
  headers?: any;
}

export let baseURL: any = process.env.VUE_APP_API_DOMAIN;

if (ENVIRONMENTS_HAVE_API_SWITCHER.indexOf(process.env.VUE_APP_ENV) !== -1 && localStorage.getItem(STORAGE_KEYS.API_DOMAIN)) {
  baseURL = localStorage.getItem(STORAGE_KEYS.API_DOMAIN);
}

export const makeRequest = async (req: TRequestType) => {
  const { url, method, data, params, headers } = req;
  return axiosObject({
    url,
    method,
    data,
    params,
    headers,
  }).then((res: any) => {
    return res.data;
  });
};
